import React from 'react';

function MissionVision() {
  return (
    <>
      <section className="page-hero">
        <h1>Mission & Vision</h1>
        <p>Our purpose and our path toward transforming agricultural financing.</p>
      </section>

      <div className="page-content">
        <div className="page-image">
          <img src="https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=800&q=80" alt="Sustainable farming" />
        </div>
        <h2>Our Mission</h2>
        <p>To create a digital agricultural financing ecosystem that empowers farmers with accessible input financing, enables suppliers to reach verified growers, and connects investors with transparent, AI-evaluated farm opportunities—all through a single, integrated platform.</p>

        <h2>Our Vision</h2>
        <p>To be the leading AI-powered agricultural financing platform in Africa and beyond, where every farmer has access to the inputs and capital they need, every supplier operates with verified demand, and every investor participates in sustainable, data-driven agricultural growth.</p>

        <h2>Core Values</h2>
        <ul>
          <li><strong>Transparency:</strong> Clear risk ratings, expected returns, and traceable transactions</li>
          <li><strong>Accessibility:</strong> WhatsApp-first design for farmers without smartphones or complex apps</li>
          <li><strong>Innovation:</strong> AI risk scoring, geospatial data, and digital vouchers</li>
          <li><strong>Sustainability:</strong> Supporting practices that protect land and livelihoods</li>
        </ul>
      </div>
    </>
  );
}

export default MissionVision;
